/**
 * @description 事件处理，入口文件
 * @author wangfupeng
 */

import statsFn from './stats'
import { query, getTargetUrl } from './query'
import resolveEvent from './resolveEvent'
import { getDomParent } from '../util'

// 富文本链接 -> 跳转事件
hrefToEvent()
/**
 * 富文本链接转为跳转事件
 */
function hrefToEvent () {
    document.body.addEventListener('click', (e) => {
        let elem = e.target
        if (elem.nodeName !== 'A') {
            // 点击的不是 <a> ，再判断上级元素
            const parent = getDomParent(elem, 'a')
            if (parent != null) {
                // 上级元素是 <a>
                elem = parent
            } else {
                // 上级元素没有 <a>
                return
            }
        }

        // 判断链接
        const link = elem.getAttribute('href')
        if (!link) {
            // 找不到链接，则忽略
            return
        }

        // 阻止默认行为和冒泡
        e.preventDefault()
        e.stopPropagation()

        // 模拟一个跳转事件，统一调用
        customInvoke({
            refId: 'dpub3-rich-text-href',
            targetUrl: link, // 直接用链接，而不是 target id
            omegaTrack: elem.textContent // 统计标识
        })
    })
}

/**
 * 触发事件的入口
 * @param {Object} eventData 事件配置，格式参考 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=239234920 中 eventTable 的一个属性值
 */
function invoke (eventData = {}) {
    // 分析 target 下游链接
    if (eventData.targetUrl) {
        // 如果有 targetUrl ，则直接取来
        eventData.target = eventData.targetUrl
    } else if (eventData.target) {
        // 没有 targetUrl ，试图从 nextUrls 找到链接
        eventData.target = getTargetUrl(eventData.target)
    }

    // 事件统计打点
    try {
        statsFn(eventData)
    } catch (ex) {
        console.error('error in stats')
    }

    // 触发事件执行
    resolveEvent(eventData)
}

/**
 * 自造事件配置，触发事件
 * @param {Object} eventData 事件配置
 */
function customInvoke (eventData = {}) {
    // 拼接
    const defaultEventData = {
        refId: 'customInvoke', // id 不传，则默认为一个字符串
        action: 'location',
        actionName: '跳转',
        eventName: 'click',
        name: '点击',
        target: '#', // url 链接
        omegaTrack: 'customInvoke-label' // 统计标识
    }
    eventData = Object.assign({}, defaultEventData, eventData)

    // 触发事件执行
    invoke(eventData)
}

export {
    query,
    getTargetUrl,
    invoke,
    customInvoke
}
